import React from 'react'
import { shallow, mount } from 'enzyme'
import AdminAutocomplete from '../AdminAutocomplete'
import Autocomplete from '../../common/Autocomplete'

describe('<AdminAutocomplete />', () => {
  let wrapper, props, instance
  beforeEach(() => {
    props = {
      admins: [
        {}
      ],
      onAdminSelect: () => {}
    }
    wrapper = shallow(<AdminAutocomplete {...props} />)
    instance = wrapper.instance()
  })
  describe('#shouldItemRender', () => {
    beforeEach(() => {
      const admins = [
        { name: 'test name', rid: 1 }
      ]
      wrapper.setProps({ admins, selectedAdmins: [] })
    })
    describe('when the value argument partially matches the "name" property of the item', () => {
      it('should return true', () => {
        const value = 'test na'
        const item = { name: 'test name' }
        expect(instance.shouldItemRender(item, value)).toBe(true)
      })
    })
    describe('when the value argument does not match any part of the "name" property of the item', () => {
      it('should return false', () => {
        const value = 'hello'
        const item = { name: 'test name' }
        expect(instance.shouldItemRender(item, value)).toBe(false)
      })
    })
  })
  describe('#onChange', () => {
    it('should update the component\'s value state with the event target\'s value', () => {
      const event = { target: { value: 'test' } }
      instance.onChange(event)
      expect(wrapper.state('value')).toBe(event.target.value)
    })
  })
  describe('#onSelect', () => {
    it('should call it\'s onAdminSelect prop', () => {
      const item = { name: 'testing' }
      const value = item.name
      const onAdminSelectMock = jest.fn()
      wrapper.setProps({ onAdminSelect: onAdminSelectMock })
      wrapper.update()
      instance.onSelect(value, item)
      expect(onAdminSelectMock).toHaveBeenCalledTimes(1)
    })
    describe('when the newAdmin prop is false', () => {
      beforeEach(() => {
        wrapper.setProps({ newAdmin: false })
      })
      it('should update the state with the provided item and value', () => {
        const item = { name: 'hello world', rid: 1 }
        const value = item.name
        instance.onSelect(value, item)
        expect(wrapper.state('selectedItem')).toBe(item)
        expect(wrapper.state('value')).toBe(value)
      })
    })
    describe('when the newAdmin prop is true', () => {
      beforeEach(() => {
        const item = { name: 'test name' }
        wrapper.setState({ value: item.name, selectedItem: item })
        wrapper.setProps({ newAdmin: true })
      })
      it('should reset the value and selectedItem state fields to blank', () => {
        const item = { name: 'hi there' }
        const value = item.name
        instance.onSelect(value, item)
        expect(wrapper.state('value')).toBe('')
        expect(wrapper.state('selectedItem')).toEqual({})
      })
    })
  })
  describe('#onDelete', () => {
    it('should call the onAdminRemove prop', () => {
      const selectedItem = { name: 'hello', rid: 1 }
      const onAdminRemoveMock = jest.fn()
      wrapper.setProps({ onAdminRemove: onAdminRemoveMock })
      wrapper.setState({ selectedItem })
      wrapper.update()
      instance.onDelete()
      expect(onAdminRemoveMock).toHaveBeenCalledWith(selectedItem.rid)
    })
  })
  describe('#renderInput', () => {
    it('should return something', () => {
      expect(instance.renderInput({})).toBeTruthy()
    })
  })
  describe('render', () => {
    it('should return an <Autocomplete />', () => {
      expect(wrapper.find(Autocomplete)).toHaveLength(1)
    })
  })
  describe('#renderItem', () => {
    it('should render the item\'s name property', () => {
      const item = { name: 'test' }
      const renderedItem = mount(instance.renderItem(item, false))
      expect(renderedItem.find('div').text()).toBe(item.name)
    })
  })
  describe('#renderMenu', () => {
    describe('when items.length > 0', () => {
      it('should render all of the provided items', () => {
        const items = [
          <span key={1} />,
          <span key={2} />
        ]
        const renderedMenu = mount(instance.renderMenu(items))
        expect(renderedMenu.find('span')).toHaveLength(items.length)
      })
    })
    describe('when there are no items', () => {
      it('should return a div', () => {
        const renderedMenu = instance.renderMenu([])
        expect(mount(renderedMenu).find('div')).toHaveLength(1)
      })
    })
  })
})
